import React, { useCallback, useMemo, useRef, useState } from "react";
import useCustomFieldsHelper from "../../../hooks/useCustomFieldsHelper";
import api from "../../../api";
import SearchTable from "../../../components/tables/SearchTable";
import { downloadFile } from "../../../utils/staticMethods";

const UsersSearchTable = ({ setLoading, ...rest }) => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const fetchIdRef = useRef(0);

  const { getColumnsForElementPeopleRoleUser } = useCustomFieldsHelper();

  const columns = useMemo(() => {
    return getColumnsForElementPeopleRoleUser();
  }, []);

  const fetchData = useCallback(
    async (pageIndex, pageSize, sortBy, filters) => {
      // Give this fetch an ID
      const fetchId = ++fetchIdRef.current;

      try {
        setLoading(true);

        var response = await api.post("usersessions/search", {
          pageIndex,
          pageSize,
          sortBy,
          filters,
        });
        if (fetchId === fetchIdRef.current) {
          setCount(response.data.count);
          setData(response.data.records);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const exportData = useCallback((pageIndex, pageSize, sortBy, filters) => {
    api
      .post("usersessions/searchexport", {
        pageIndex,
        pageSize,
        sortBy,
        filters,
      })
      .then((response) => {
        downloadFile(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <React.Fragment>
      <SearchTable
        columns={columns}
        data={data}
        fetchData={fetchData}
        exportData={exportData}
        count={count}
        reportType={"users"}
        {...rest}
      />
    </React.Fragment>
  );
};

export default UsersSearchTable;
